export const FieldworkReportStatus = {
  awaiting: "awaiting",
  cati: "cati",
  completed: "completed",
  duplicate: "duplicate",
  email: "email",
  whatsapp: "whatsapp",
  expired: "expired",
  failed: "failed",
  imported: "imported",
  "in-process": "inProcess",
  "not-valid": "notValid",
  technical: "technical",
  qualitative: "qualitative",
  pending: "pending",
  phone: "phone",
  sent: "sent",
  sms: "sms",
  unique: "unique",
  "total-contact": "valid",
  ivr: "ivr",
  screeningQuestion: "screeningQuestion"
} as const;

export interface FieldworkReportSummary {
  awaiting: string;
  cati: string;
  completed: string;
  duplicate: string;
  email: string;
  whatsApp: string;
  expired: string;
  failed: string;
  imported: string;
  inProcess: string;
  notValid: string;
  technical: string;
  qualitative: string;
  pending: string;
  phone: string;
  sent: string;
  sms: string;
  unique: string;
  valid: string;
  ivr: string;
  screeningQuestion: string
}

export class FieldworkReportSummary implements FieldworkReportSummary {
  constructor(data?: Partial<FieldworkReportSummary>) {
    this.awaiting = data?.awaiting || "0";
    this.cati = data?.cati || "0";
    this.completed = data?.completed || "0";
    this.duplicate = data?.duplicate || "0";
    this.email = data?.email || "0";
    this.whatsApp = data?.whatsApp || "0";
    this.expired = data?.expired || "0";
    this.failed = data?.failed || "0";
    this.imported = data?.imported || "0";
    this.inProcess = data?.inProcess || "0";
    this.notValid = data?.notValid || "0";
    this.technical = data?.technical || "0";
    this.qualitative = data?.qualitative || "0";
    this.pending = data?.pending || "0";
    this.phone = data?.phone || "0";
    this.sent = data?.sent || "0";
    this.sms = data?.sms || "0";
    this.unique = data?.unique || "0";
    this.valid = data?.valid || "0";
    this.ivr = data?.ivr || "0";
    this.screeningQuestion = data?.screeningQuestion || "0";
  }
}
